import { apiBudgetUpdate, QuotationInfo } from "Types";

export const parseBudgetInfo = (data: QuotationInfo, id: number): apiBudgetUpdate => {
  const formattedData = {
    companyQuotationId: id,
    alreadyReceivedBudget: data.alreadyReceivedBudget,
    amount: data.amount,
    description: data.description,
    deadline: data.deadline,
    paymentMethods: data.paymentMethods
  } as apiBudgetUpdate

  return formattedData
}

export default {
  parseBudgetInfo
}